import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { AppTheme } from "../../theme/App.theme";

const MUIDatePicker = ({
  DefaultValue,
  Value,
  OnChange,
  Name,
  Id,
  Disabled,
  Label,
  PlaceHolder,
  HelperText,
  Error,
  EnablePast,
  DisableFuture,
  OnBlur,
  ShouldDisableCurrentDate,
  MinDate,
  MaxDate,
}) => {
  const handleKeyDown = (event) => {
    event.preventDefault();
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        disabled={Disabled}
        name={Name}
        defaultValue={dayjs(DefaultValue)}
        sx={{
          backgroundColor: Disabled && AppTheme.MUTED_LIGHT
        }}
        value={dayjs(Value)}
        disablePast={EnablePast ? false : true}
        disableFuture={DisableFuture ? true : false}
        shouldDisableDate={ShouldDisableCurrentDate}
        minDate={MinDate}
        maxDate={MaxDate}
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            name: Name,
            id: Id,
            helperText: HelperText,
            error: Error,
            label: Label,
            placeholder: PlaceHolder || Label,
            onBlur: OnBlur,
            inputProps: {
              readOnly: true,
              onKeyDown: (event) => handleKeyDown(event)
            },
          },
        }}
        format="DD/MM/YYYY"
        onChange={(newValue) => {
          if (!EnablePast && newValue.isBefore(dayjs(), "day")) {
            const event = {
              target: { value: dayjs().startOf("day").toDate().getTime(), name: Name },
            };
            OnChange(event);
          } else {
            const event = {
              target: { value: new Date(newValue).getTime(), name: Name },
            };
            OnChange(event);
          }
        }}
      />
    </LocalizationProvider>
  );
};

export default MUIDatePicker;